import type { JSX } from 'react';

import { useLocation } from 'react-router';

import { Redirect } from '@change-corgi/core/react/router';

import { useStepState } from 'src/app/pages/startAPetition/pageContext';
import { useLoginState } from 'src/app/shared/hooks/session';

const LOGIN_REDIRECT_PATH = '/login_or_join';

export function RedirectUnauthorized(): JSX.Element | null {
	const { data } = useStepState();
	const loginState = useLoginState();
	const location = useLocation();

	if (data.currentStep.isAuthenticationRequired && loginState !== 'AUTHENTICATED') {
		const redirectUrl = encodeURIComponent(location.pathname + location.search);
		return <Redirect to={`${LOGIN_REDIRECT_PATH}?redirectTo=${redirectUrl}&user_flow=future_sap`} />;
	}

	return null;
}
